import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useServiceOrder } from './ServiceOrderLoader'
import { getAssetIds } from '../_helpers/pdfHelpers'

const Context = React.createContext([])
const { Provider } = Context
export const useDevicesFieldsValuesState = () => React.useContext(Context)
export const useDevicesFieldValues = () => useDevicesFieldsValuesState()?.places

const QUERY = gql`
  query Places($filter: PlaceFilter) {
    places(limit: 9999, filter: $filter) {
      id
      name
      placeLevelsResume
      fieldValues {
        id
        value
        field {
          id
          name
        }
      }
    }
  }
`

const DevicesFieldValuesLoader = ({ children }) => {
  const serviceOrder = useServiceOrder()
  const assetIds = getAssetIds(serviceOrder)
  const filter = { types: ['aparelho'], includeDisabled: true }
  if (assetIds?.length) {
    filter.ids = assetIds
  }
  let { data, ...state } = useQuery(QUERY, {
    variables: { filter },
    client: placesClient
  })

  return (
    <StatePresenter {...state} noEmptyMessage>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default DevicesFieldValuesLoader
